import { render } from "./PageSlider2.vue?vue&type=template&id=03078828"
import script from "./PageSlider2.vue?vue&type=script&lang=js"
export * from "./PageSlider2.vue?vue&type=script&lang=js"

import "./PageSlider2.vue?vue&type=style&index=0&id=03078828&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__